import _regeneratorRuntime from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _slicedToArray from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { getMasterDataSchemaApi, getMasterDataSitesApi } from '@/api/selfAnalysis';
import TopologyNodesPanel from '@/components/selfAnalysis/TopologyNodesPanel.vue';
import VoltageConfigsPanel from '@/components/selfAnalysis/VoltageConfigsPanel.vue';
import InverterMasterPanel from '@/components/selfAnalysis/InverterMasterPanel.vue';
import MpptStringMapPanel from '@/components/selfAnalysis/MpptStringMapPanel.vue';
import StringDesignPanel from '@/components/selfAnalysis/StringDesignPanel.vue';
import StatusCodesPanel from '@/components/selfAnalysis/StatusCodesPanel.vue';

/**
 * 自主分析：MPPT 電壓異常診斷要用的案場主檔維護（見 ADR-0011）。
 *
 * 六個分頁對到 Cloud SQL `trend_analytics` 的六張表（02～07）。07 由品牌庫 `inverter_status_codes` 依 04 的品牌帶入。這個庫跟 `postgres` 庫是分開的，
 * 做不到跨庫 JOIN，所以案場清單是後端另外跟 Cosmos 要的（`/api/trendanalytics/sites`），
 * **不是** Cloud SQL 那張 factories_info —— 那張只有 8 列而且沒有 f001。
 *
 * 欄位定義一律跟後端要（`/api/trendanalytics/schema`），前端不抄一份，免得跟 DDL 走鐘。
 */
export default {
  name: 'SelfAnalysis',
  components: {
    TopologyNodesPanel: TopologyNodesPanel,
    VoltageConfigsPanel: VoltageConfigsPanel,
    InverterMasterPanel: InverterMasterPanel,
    MpptStringMapPanel: MpptStringMapPanel,
    StringDesignPanel: StringDesignPanel,
    StatusCodesPanel: StatusCodesPanel
  },
  data: function data() {
    return {
      schema: null,
      siteList: [],
      siteCode: '',
      tabIndex: 0,
      error: ''
    };
  },
  computed: {
    /** 已經有主檔資料的排前面，後面標幾列，不用逐一點開才知道哪些建過 */siteOptions: function siteOptions() {
      var label = function label(s) {
        return "".concat(s.code, " \u2014 ").concat(s.name) + (s.rows ? "\uFF08\u5DF2\u6709 ".concat(s.rows, " \u5217\uFF09") : '');
      };
      var done = this.siteList.filter(function (s) {
        return s.rows;
      });
      var rest = this.siteList.filter(function (s) {
        return !s.rows;
      });
      var opt = function opt(s) {
        return {
          value: s.code,
          text: label(s)
        };
      };
      if (!this.siteList.length) return [];
      return [{
        value: '',
        text: '（請選案場）'
      }].concat(_toConsumableArray(done.length ? [{
        label: '已建主檔',
        options: done.map(opt)
      }] : []), [{
        label: '其他案場',
        options: rest.map(opt)
      }]);
    },
    withData: function withData() {
      return this.siteList.filter(function (s) {
        return s.rows;
      });
    }
  },
  created: function created() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _this$withData$, _yield$Promise$all, _yield$Promise$all2, schemaRes, sitesRes;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return Promise.all([getMasterDataSchemaApi(), getMasterDataSitesApi()]);
            case 3:
              _yield$Promise$all = _context.sent;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
              schemaRes = _yield$Promise$all2[0];
              sitesRes = _yield$Promise$all2[1];
              _this.schema = schemaRes.data;
              _this.siteList = sitesRes.data || [];
              // 已經建過主檔的排第一個，直接開，省一次點選
              _this.siteCode = ((_this$withData$ = _this.withData[0]) === null || _this$withData$ === void 0 ? void 0 : _this$withData$.code) || '';
              _context.next = 15;
              break;
            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](0);
              _this.error = (_context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.msg) || (_context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.message) || '連不到主檔資料庫（trend_analytics）';
            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 12]]);
    }))();
  },
  methods: {
    /** 表格存過東西之後重抓，讓下拉的「已有幾列」跟著動。失敗就沿用舊的，不擋操作 */loadSites: function loadSites() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return getMasterDataSitesApi();
              case 3:
                res = _context2.sent;
                _this2.siteList = res.data || _this2.siteList;
                _context2.next = 10;
                break;
              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](0);
                console.log('reload sites failed', _context2.t0);
              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 7]]);
      }))();
    }
  }
};